import keycloakService from "../services/keycloakService";

const PrivateRoute = ({ children }) => (keycloakService.isLoggedIn()) ? children : null;

export default PrivateRoute